export enum LoanOtherIncomeType {
    ACCESSORY_UNIT_INCOME = 'accessory_unit_income',
    ALIMONY = 'alimony',
    AUTOMOBILE_ALLOWANCE = 'automobile_allowance',
    BOARDER_INCOME = 'boarder_income',
    CAPITAL_GAINS = 'capital_gains',
    CHILD_SUPPORT = 'child_support',
    DEFINED_CONTRIBUTION_PLAN = 'defined_contribution_plan',
    DISABILITY = 'disability',
    DIVIDENDS_OR_INTEREST = 'dividends_or_interest',
    EMPLOYMENT_RELATED_ASSETS = 'employment_related_assets',
    FOREIGN_INCOME = 'foreign_income',
    FOSTER_CARE = 'foster_care',
    HOUSING_CHOICE_VOUCHER = 'housing_choice_voucher',
    HOUSING_OR_PARSONAGE = 'housing_or_parsonage',
    MISCELLANEOUS_INCOME = 'miscellaneous_income',
    MORTGAGE_CREDIT_CERTIFICATE = 'mortgage_credit_certificate',
    MORTGAGE_DIFFERENTIAL_PAYMENT = 'mortgage_differential_payment',
    NON_BORROWER_HOUSEHOLD_INCOME = 'non_borrower_household_income',
    NOTES_RECEIVABLE = 'notes_receivable',
    OTHER_NON_EMPLOYMENT = 'other_non_employment',
    PUBLIC_ASSISTANCE = 'public_assistance',
    RETIREMENT = 'retirement',
    ROYALTY_PAYMENT = 'royalty_payment',
    SEASONAL_INCOME = 'seasonal_income',
    SEPARATE_MAINTENANCE = 'separate_maintenance',
    SOCIAL_SECURITY = 'social_security',
    SOCIAL_SECURITY_DISABILITY = 'social_security_disability',
    TEMPORARY_LEAVE = 'temporary_leave',
    TIP_INCOME = 'tip_income',
    TRAILING_CO_BORROWER_INCOME = 'trailing_co_borrower_income',
    TRUST = 'trust',
    UNEMPLOYMENT = 'unemployment',
    VA_COMPENSATION = 'va_compensation',
    WORKERS_COMPENSATION = 'workers_compensation'
  }
  
  export const LoanOtherIncomeTypeLabels = {
    [LoanOtherIncomeType.ACCESSORY_UNIT_INCOME]: 'Accessory Unit Income',
    [LoanOtherIncomeType.ALIMONY]: 'Alimony',
    [LoanOtherIncomeType.AUTOMOBILE_ALLOWANCE]: 'Automobile Allowance',
    [LoanOtherIncomeType.BOARDER_INCOME]: 'Boarder Income',
    [LoanOtherIncomeType.CAPITAL_GAINS]: 'Capital Gains',
    [LoanOtherIncomeType.CHILD_SUPPORT]: 'Child Support',
    [LoanOtherIncomeType.DEFINED_CONTRIBUTION_PLAN]: 'Defined Contribution Plan',
    [LoanOtherIncomeType.DISABILITY]: 'Disability',
    [LoanOtherIncomeType.DIVIDENDS_OR_INTEREST]: 'Dividends or Interest',
    [LoanOtherIncomeType.EMPLOYMENT_RELATED_ASSETS]: 'Employment Related Assets',
    [LoanOtherIncomeType.FOREIGN_INCOME]: 'Foreign Income',
    [LoanOtherIncomeType.FOSTER_CARE]: 'Foster Care',
    [LoanOtherIncomeType.HOUSING_CHOICE_VOUCHER]: 'Housing Choice Voucher',
    [LoanOtherIncomeType.HOUSING_OR_PARSONAGE]: 'Housing or Parsonage',
    [LoanOtherIncomeType.MISCELLANEOUS_INCOME]: 'Miscellaneous Income',
    [LoanOtherIncomeType.MORTGAGE_CREDIT_CERTIFICATE]: 'Mortgage Credit Certificate',
    [LoanOtherIncomeType.MORTGAGE_DIFFERENTIAL_PAYMENT]: 'Mortgage Differential Payment',
    [LoanOtherIncomeType.NON_BORROWER_HOUSEHOLD_INCOME]: 'Non-Borrower Household Income',
    [LoanOtherIncomeType.NOTES_RECEIVABLE]: 'Notes Receivable',
    [LoanOtherIncomeType.OTHER_NON_EMPLOYMENT]: 'Other (Non-Employment)',
    [LoanOtherIncomeType.PUBLIC_ASSISTANCE]: 'Public Assistance',
    [LoanOtherIncomeType.RETIREMENT]: 'Retirement (e.g./ Pension, IRA)',
    [LoanOtherIncomeType.ROYALTY_PAYMENT]: 'Royalty Payment',
    [LoanOtherIncomeType.SEASONAL_INCOME]: 'Seasonal Income',
    [LoanOtherIncomeType.SEPARATE_MAINTENANCE]: 'Separate Maintenance',
    [LoanOtherIncomeType.SOCIAL_SECURITY]: 'Social Security',
    [LoanOtherIncomeType.SOCIAL_SECURITY_DISABILITY]: 'Social Security Disability',
    [LoanOtherIncomeType.TEMPORARY_LEAVE]: 'Temporary Leave',
    [LoanOtherIncomeType.TIP_INCOME]: 'Tip Income',
    [LoanOtherIncomeType.TRAILING_CO_BORROWER_INCOME]: 'Trailing Co-Borrower Income',
    [LoanOtherIncomeType.TRUST]: 'Trust',
    [LoanOtherIncomeType.UNEMPLOYMENT]: 'Unemployment',
    [LoanOtherIncomeType.VA_COMPENSATION]: 'VA Compensation',
    [LoanOtherIncomeType.WORKERS_COMPENSATION]: 'Workers\' Compensation'
  }
  
  export const LoanOtherIncomeTypeOptions = Object.values(LoanOtherIncomeType).map(value => ({
    value,
    label: LoanOtherIncomeTypeLabels[value as LoanOtherIncomeType]
  }))
  